export default __webpack_public_path__ + "static/homepage_AU-3aa13a874f6460a24bf76dfed78749e9.mp4";